export default function (error) {
    console.error(error);
}
